import { bootstrap } from "./bootstrapper";

import { module as fseg } from "@/@modules/fseg";
import { module as dcm } from "@/@modules/dcm";

bootstrap(fseg, dcm);